import { SimpleForm,TextInput,ImageInput } from 'react-admin';
// TODO: custom image input pour fit avec le format ImageInput du schéma
export const UserEditInputs = (props:any) => (
    <SimpleForm sanitizeEmptyValues={true} onSubmit={props.userSave}>
        <TextInput source="firstName" />
        <TextInput source="lastName" />
        <TextInput type="email" source="email" />  
        <ImageInput source="avatarImage" />        
    </SimpleForm>
)